import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPage } from './SignInPage';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SignInPage],
});
